// extracted by mini-css-extract-plugin
export var active = "_mh-2";
export var recordingDot = "_mh-1";
export var recordingIndicator = "_mh-0";